/**
 * ContactSection — wraps ContactForm with the 2-column section layout from
 * the AI-IDE original (info on left, form on right inside a glass card).
 */
import ContactForm from '@/components/landing/ContactForm';

export default function ContactSection({ sourcePage = 'home' }) {
  return (
    <section id="contact" className="section-padding light-bg">
      <div className="container signup-box-wrapper">
        <div className="signup-glow" />
        <div className="signup-card">
          <div className="signup-grid">
            <div className="signup-info">
              <h2>Contact Us</h2>
              <p>
                Have questions about Yukti? Whether you&apos;re a student,
                parent, or educator, we&apos;re here to help.
              </p>
              <ul
                className="signup-benefits-list"
                style={{
                  marginTop: 24, listStyle: 'none', padding: 0,
                  display: 'flex', flexDirection: 'column', gap: 16,
                }}
              >
                <li style={{ display: 'flex', alignItems: 'center', gap: 12, paddingLeft: 0, background: 'none' }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--color-orange)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                    <polyline points="22,6 12,13 2,6" />
                  </svg>
                  <span>support@yuktilearning.com</span>
                </li>
              </ul>
            </div>
            <div className="signup-form-container">
              <ContactForm sourcePage={sourcePage} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
